import React, { Component } from 'react';
import SortIcon from './SortIcon';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  wrapper: {
    cursor: 'pointer'
  },
  label: {
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    '& > label': {
      cursor: 'pointer'
    }
  },
  sort: {
    display: 'inline-block',
    width: '100%'
  }
};
const HeaderCell = props => {
  const sort = () => {
    if (props.filterCriteria) {
      const asc = props.filterCriteria.asc === 'asc' ? 'desc' : 'asc';
      return () => props.onClick({
        sort: props.appId,
        asc
      });
    }
    return () => null;
  };
  const renderSortIcon = () => {
    if (props.filterCriteria && props.appId === props.filterCriteria.sort) {
      return /*#__PURE__*/React.createElement("span", {
        className: props.classes.sort
      }, /*#__PURE__*/React.createElement(SortIcon, {
        asc: props.filterCriteria.asc
      }));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: props.classes.wrapper,
    onClick: sort(),
    "data-testid": "headerCell"
  }, /*#__PURE__*/React.createElement("span", {
    className: props.classes.label
  }, /*#__PURE__*/React.createElement("label", {
    title: props.children
  }, props.children)), renderSortIcon());
};
export default withStyles(styles)(HeaderCell);